import FlexColumn from "./FlexColumn.jsx";

const Page = ({ children }) => {
  return (
    <FlexColumn fullHeight fullWidth>
      {children}
    </FlexColumn>
  );
};

export default Page;
